enum ViewMode {
  Table = 0,
  Board = 1,
}

export default ViewMode;
